var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable react/no-array-index-key */
import React from 'react';
import styled from 'styled-components';
import Image from '../../Image';
import { withSkeleton } from '../../Skeleton';
import CustomFlag from './CustomFlag';
var FlagsWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  overflow: hidden;\n  ", "\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  overflow: hidden;\n  ",
    "\n"])), function (_a) {
    var top = _a.top;
    return top
        ? 'top: 0; flex-direction: column; max-height: 60%;'
        : 'bottom: 0; flex-direction: column-reverse; max-height: 40%;';
});
var Flag = styled(Image)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  ", ";\n"], ["\n  margin: 0;\n  ",
    ";\n"])), function (_a) {
    var top = _a.top;
    return top
        ? 'width: 2.25rem; height: auto; margin: 0 0.18rem 0.18rem 0;'
        : 'min-width: 2.25rem; max-width: calc(50% - 0.185rem); height: auto; margin: 0.18rem 0.18rem 0 0;';
});
export var ProductFlags = function (_a) {
    var flagCustom = _a.flagCustom, flagsTop = _a.flagsTop, flagsBottom = _a.flagsBottom, name = _a.name;
    return (React.createElement(React.Fragment, null,
        ((flagsTop && Boolean(flagsTop.length)) || (flagCustom && flagCustom.text)) && (React.createElement(FlagsWrapper, { "data-testid": "flags-wrapper-top", top: true },
            flagCustom && React.createElement(CustomFlag, { text: flagCustom.text }),
            flagsTop &&
                flagsTop.map(function (flagUrl, index) { return (React.createElement(Flag, { alt: name, "data-testid": "flag-top", fallback: function () { return null; }, key: flagUrl + "-" + name + "-" + index, src: flagUrl, top: true })); }))),
        flagsBottom && Boolean(flagsBottom.length) && (React.createElement(FlagsWrapper, { "data-testid": "flags-wrapper-bottom" }, flagsBottom.map(function (flagUrl, index) { return (React.createElement(Flag, { alt: name, "data-testid": "flag-bottom", fallback: function () { return null; }, key: flagUrl + "-" + name + "-" + index, src: flagUrl })); })))));
};
export default withSkeleton(ProductFlags, function () { return null; });
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map